import React from "react";
import { IconsInterface } from "../../entities/Icon";

const JarIcon: React.FC<IconsInterface> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="115.5"
    height="141.43"
    viewBox="0 0 115.5 141.43"
    className={className}
  >
    <g id="Group_227" data-name="Group 227" transform="translate(-5549 788)">
      <path
        id="Path_447"
        data-name="Path 447"
        d="M166.545,199.48H66.325c-4.31,0-7.79,3.98-7.63,8.8a8.16,8.16,0,0,0,7.83,8.16h.03a.035.035,0,0,1,.02.01l15.37,123.18a1.39,1.39,0,0,0,1.32,1.28h65.91a1.381,1.381,0,0,0,1.32-1.27l15.8-123.19a.035.035,0,0,1,.02-.01h.03a8.169,8.169,0,0,0,7.84-8.16C174.345,203.46,170.855,199.48,166.545,199.48Zm-2.94,16.96-2.17,16.91-.38,2.97-.36,2.82h-40.59a1.3,1.3,0,0,0-.93.44,1.6,1.6,0,0,0-.38,1.05,1.4,1.4,0,0,0,1.31,1.48h40.21l-12.21,95.2a.709.709,0,0,1-.67.64H85.015a.708.708,0,0,1-.66-.65L69.265,216.44v-.03h94.35Zm3.07-2.97H66.205a5.315,5.315,0,0,1-4.85-5.75.17.17,0,0,1,.01-.07,5.308,5.308,0,0,1,5.11-5.21h100.07a5.553,5.553,0,0,1,.13,11.03Z"
        transform="translate(5490.31 -987.48)"
        fill="#092940"
      />
      <circle
        id="Ellipse_58"
        data-name="Ellipse 58"
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="translate(5604.242 -748.356)"
        fill="#092940"
      />
      <path
        id="Path_449"
        data-name="Path 449"
        d="M158.355,243.95l-2.91,22.68H77.355l-2.83-22.68Z"
        transform="translate(5490.31 -987.48)"
        fill="#8bb839"
        opacity="1"
        className="jar-line"
      />
      <path
        id="Path_450"
        data-name="Path 450"
        d="M155.415,267.19l-2.91,22.68H80.3l-2.83-22.68Z"
        transform="translate(5490.31 -987.48)"
        fill="#8bb839"
        opacity="1"
        className="jar-line"
      />
      <path
        id="Path_451"
        data-name="Path 451"
        d="M152.475,290.43l-2.91,22.67H83.235L80.4,290.43Z"
        transform="translate(5490.31 -987.48)"
        fill="#8bb839"
        opacity="1"
        className="jar-line"
      />
      <path
        id="Path_448"
        data-name="Path 448"
        d="M149.535,313.66l-2.83,22.07a.675.675,0,0,1-.63.61H86.735a.675.675,0,0,1-.63-.61l-2.76-22.07Z"
        transform="translate(5490.31 -987.48)"
        fill="#8bb839"
        opacity="1"
        className="jar-line"
      />
    </g>
  </svg>
);

export default JarIcon;
